.round-robin {
    color: var(--grey-lt);
}

.name {
    margin-right: 6px;
}
